import * as RSUMODConstants from './RSUMODConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isModDataFetching: false,
    isModDataFetched: false,
    isModDataFetchFailed: false,
    rsuModList:[],
    dateTimeOrderDesc: true,
    resumeModId: null,
    showResume: false,
    filteredModList:[]
};

export default function RSUMODReducer(state = initialState, action) {

    const getUpdatedRSUModList = (modId, newstatus) => {
        let modList = JSON.parse(JSON.stringify(state.rsuModList))
        let findModObj = modList.find(elem => elem.modId == modId)
        findModObj.modStatus = newstatus;
        return modList;
    }

    const getUpdatedFilteredRSUModList = (modId, newstatus) => {
        let modList = JSON.parse(JSON.stringify(state.filteredModList))
        let findModObj = modList.find(elem => elem.modId == modId)
        findModObj.modStatus = newstatus;
        return modList;
    }

    switch(action.type){

        case RSUMODConstants.GET_RSU_MOD_LIST:
                return assign({}, state, {
                    isModDataFetching: true,
                    isModDataFetched: false,
                    isModDataFetchFailed: false
                });
            break;
        case RSUMODConstants.GET_RSU_MOD_SUCCESS:
                const modList = action.newState.result
                
                let modelList = modList.map(elem=>elem.modelName).filter((item, i, ar) => ar.indexOf(item) === i && (typeof item === 'string' && item.trim().length != 0)).map(
                    item=>{
                        return  {
                                    label: item,
                                    value: item
                    };
                    }
                );
                return assign({}, state, {
                    isModDataFetching: false,
                    isModDataFetched: true,
                    isModDataFetchFailed: false,
                    rsuModList: action.newState.result,
                    modModelList:modelList,
                    filteredModList: action.newState.result
                });
            break;
        case RSUMODConstants.GET_RSU_MOD_FAILURE:
                return assign({}, state, {
                    isModDataFetching: false,
                    isModDataFetched: false,
                    isModDataFetchFailed: true
                });
                break;  
        case RSUMODConstants.FILTERED_MOD_LIST:
                return assign({}, state, {
                    isModDataFetching: false,
                    isModDataFetched: true,
                    filteredModList: action.newState.filteredModList
                });
        break;         
        case RSUMODConstants.SET_DATE_TIME_ORDER:
            return assign({}, state, {
                dateTimeOrderDesc: !state.dateTimeOrderDesc
            });
            break;  
        case RSUMODConstants.SET_MOD_PAUSE_ACTION:
            return assign({}, state, {
                rsuModList: getUpdatedRSUModList(action.pauseModId, RSUMODConstants.PAUSE_ACTION_IN_PROGRESS),
                filteredModList: getUpdatedFilteredRSUModList(action.pauseModId, RSUMODConstants.PAUSE_ACTION_IN_PROGRESS)
            });
            break;
        case RSUMODConstants.SET_MOD_PAUSE_ACTION_FAILURE:
            //When pause failed, set it to previous state of "MOD_CREATED"
            return assign({}, state, {
                rsuModList: getUpdatedRSUModList(action.pauseModId, RSUMODConstants.MOD_CREATED),
                filteredModList: getUpdatedFilteredRSUModList(action.pauseModId, RSUMODConstants.MOD_CREATED)
            });
            break;
        case RSUMODConstants.SET_MOD_PAUSE_ACTION_SUCCESS:
            return assign({}, state, {
                rsuModList: getUpdatedRSUModList(action.pauseModId, RSUMODConstants.RSUJOB_PAUSE_REQUESTED),
                filteredModList: getUpdatedFilteredRSUModList(action.pauseModId, RSUMODConstants.RSUJOB_PAUSE_REQUESTED)
            });
            break;
        case RSUMODConstants.SET_MOD_RESUME_ACTION:
            return assign({}, state, {
                rsuModList: getUpdatedRSUModList(action.resumeModId, RSUMODConstants.RESUME_ACTION_IN_PROGRESS),
                filteredModList: getUpdatedFilteredRSUModList(action.resumeModId, RSUMODConstants.RESUME_ACTION_IN_PROGRESS)
            });
            break;
        case RSUMODConstants.SET_MOD_RESUME_ACTION_FAILURE:
            //When resume failed, set it to previos state of "PauseRequested"
            return assign({}, state, {
                rsuModList: getUpdatedRSUModList(action.resumeModId, RSUMODConstants.RSUJOB_PAUSE_REQUESTED),
                filteredModList: getUpdatedFilteredRSUModList(action.resumeModId, RSUMODConstants.RSUJOB_PAUSE_REQUESTED)
            });
            break;
        case RSUMODConstants.SET_MOD_RESUME_ACTION_SUCCESS:
            return assign({}, state, {
                rsuModList: getUpdatedRSUModList(action.resumeModId, RSUMODConstants.RSUJOB_RESUME_REQUESTED),
                filteredModList: getUpdatedFilteredRSUModList(action.resumeModId, RSUMODConstants.RSUJOB_RESUME_REQUESTED)
            });
            break;
        case RSUMODConstants.SHOW_RESUME_CONFIRMATION:
            return assign({}, state, {
                resumeModId: action.resumeModId,
                showResumeConfirmation: true
            });
            break;
        case RSUMODConstants.HIDE_RESUME_CONFIRMATION:
            return assign({}, state, {
                resumeModId: null,
                showResumeConfirmation: false
            });
            break;
        default:
            return state;

    }

}